<script>
    import {push} from 'svelte-spa-router';
    import Header from './Header.svelte';
    export let params = {}

    import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	const modal = writable(null);

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
    }

    let dash_token_link = dash_token;
	if (dash_token_link != '1') {
		dash_token_link = '2'
	}

    let mebot_id = getCookie('m_id');
    if (mebot_id == '') {
        mebot_id = 0;
    }
    let item_id = params.item_id


    let mebot_trips = [];
	let mebot_trips_tmp = [];
	let mebot_attr = [];

    let social_link = null;
	let social_msg = null;
	let copied = false;
	let timeout_id;
	let show_close = true;


	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('news');

    async function getMebotNews(mebot_id) {

		const res = await fetch(
			"https://api.forever.today/?method=get_mebot_news_item",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
                    item_id
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.trips;

		mebot_attr = json.data.attr;
		mebot_trips_tmp = [];
		let info_str = '';
		let land = null;

		for (const runner of runners) {

			land = null;
			if (runner.info != null) {
				info_str = runner.info

				if (runner.land_img != null) {
					land = runner.land_img
				}
			} else {
				info_str = runner.eff + '%'
			}
			mebot_trips_tmp.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				land_img: land,
				land_file_id: runner.land_file_id,
				sparkles: runner.sparkles,
				eff: runner.eff,
				info: info_str,
				time_ago: runner.time_ago
			});
    		//social_link = runner.slink;
            social_link = 'https://play.mebots.xyz/#/i/2/' + runner.ts;

		}
		//mebot_trips = mebot_trips_tmp.slice(0, 14);
		mebot_trips = mebot_trips_tmp;

	}

    getMebotNews(0);

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {
		//copyError();
		//return;
		copied = true;
		if (copied == true) {
			setTimeout(
				function() {
					copied = false;
					showLinkCopied()
				},
			300
			);
		}
	}

	function copyError() {

		displayMebotMessage(`
		<center>
		<br><br>
		🔗 News link:<br><br>
		<input value="` + social_link + `"></input>
		<br><br><br>

		`, 100000);
	}

	function copyNewsLink() {
		var copyText = document.getElementById("social_link");

		copyToClipboard(copyText.value)
			.then(() => copySuccess() )
			.catch(() => copyError() );

	}

	function showLinkCopied() {

		displayMebotMessage(`
		<center>
		<br><br><br>
		🔗 News link copied to your clipboard.<br><br>
		<br>
        `, 100000, 'Copy');
	}

	let y;

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>

<!--<center>
    <div style="width: 300px; overflow: hidden">
        <iframe title="iframe" src="/ifeed.html" width="307" height="800"
            scrolling="yes" style="width: 307px; height: 800px; border:none;"
            allowtransparency="true">
            Mebots content            
        </iframe>
    </div>
</center>-->

<center>
<table width=300px border=0>
    <tr height="40px">
        <td width=50px align=center>
            &nbsp;
        </td>
        <td align=center>
            <table border=0 width=200px cellspacing=0 cellpadding=0><tr>
                <td>&nbsp;</td>
            </tr></table>
        </td>
        <td width=50px align=right  on:click={ copyNewsLink }>
            <div class="text-electric" >
                <input size="22" type="hidden" id="social_link" bind:value={social_link} >
                <span class="tooltip" style="font-size: 10px; white-space: nowrap;" class:copy-pulsing={ copied }> <span>&nbsp;🔗&nbsp;</span> </span>
            </div>
        </td>
    </tr>
</table>
<br>
<div class="main1">
    <table width=340px valign=middle border=0>
    {#each mebot_trips as trip, i}
    <tr height=65px>
    <td align=left valign=top width=50px style="padding-top: 2px; padding-bottom: 4px;">
        {#if trip.land_img != null}
            <div class="message question no_tap_zoom" on:click={ () => { push('/habitat/' + dash_token_link + '/' + trip.land_file_id) } }> &nbsp; <img src="{trip.land_img}" class="no_tap_zoom land_sm" style="user-select: none;" width=32px height=32px alt="Land42"></div>
        {:else}
            <div class="message question no_tap_zoom" on:click={ () => { push('/stats/' + dash_token_link + '/' + mebot_id + '/' + trip.id) } }> &nbsp; <img src="{trip.img}" class="no_tap_zoom" style="user-select: none;" width=38px height=38px alt="Mebot"></div>
        {/if}
    </td>
    <td width=160px valign=top style="padding-bottom: 10px;"> <span class="vitals-mid text-glow-blueish">{@html trip.info }</span> </td>
    <td width=50px align=right valign=top> <span class="vitals-small text-glow-gray">{trip.time_ago}</span> &nbsp;</td>
    </tr>
    {/each}
    </table>
    <br><br><br><br><br><br>
</div>
</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

.main1 {
    border-radius: 20px;
    background-color: rgba(0, 24, 39, 0.6);
    background-color: linear-gradient(rgba(0, 24, 39, 0.6), rgba(0,0,0,0.6));
    height: 700px;
    width: 370px;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    padding: 0px;
    overscroll-behavior: auto;
    border: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.main1::-webkit-scrollbar {
  display: none;
}

.main {
		background-color: rgba(0, 0, 0, 0.465);
		overflow-x: auto;
		overflow-y: auto;
		background-image: url("/img/nyc_bg_sm.jpeg");
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		touch-action: manipulation;
		overflow: auto;
		-webkit-appearance: none;
		overscroll-behavior: auto;
    height: 4000px;  
    margin-top: 50px;
}

.vitals-small {
	font-size: 12px;
}

.vitals-mid {
	font-size: 14px;
}

.text-glow-blueish {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: hsl(185, 40%, 70%);
}

.text-glow-gray {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: rgba(255, 255, 255, 0.465);
}

.land_sm {
	border-radius: 10px;
}

.copy-pulsing {
	font-weight: bold;
	transform: scale(1);
	animation: zombie-fight 0.3s;
}

</style>